import React, { useState, useEffect } from 'react';
import AdminSidebar from './AdminSidebar';
import DashboardHome from './DashboardHome';
import ManageMatches from './ManageMatches';
import ManagePayments from './ManagePayments';
import ManageUsers from './ManageUsers';
import ManageTeams from './ManageTeams';
import ManageSettings from './ManageSettings';
import { useAuth } from '../../context/AuthContext';

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, logout } = useAuth();

  // Check if user is admin
  useEffect(() => {
    if (user && !user.is_admin) {
      logout();
    }
  }, [user, logout]);

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <DashboardHome />;
      case 'matches':
        return <ManageMatches />;
      case 'payments':
        return <ManagePayments />;
      case 'users':
        return <ManageUsers />;
      case 'teams':
        return <ManageTeams />;
      case 'settings':
        return <ManageSettings />;
      default:
        return <DashboardHome />;
    }
  };

  if (!user || !user.is_admin) {
    return null; // Will be redirected by useEffect
  }

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Desktop sidebar - always visible on md+ */}
      <div className="hidden md:block">
        <AdminSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black/50"
            onClick={() => setSidebarOpen(false)}
          />
          {/* Sidebar panel */}
          <div className="fixed inset-y-0 left-0 w-64">
            <AdminSidebar
              activeTab={activeTab}
              setActiveTab={(tab) => {
                setActiveTab(tab);
                setSidebarOpen(false);
              }}
              onClose={() => setSidebarOpen(false)}
            />
          </div>
        </div>
      )}

      {/* Main content area */}
      <div className="flex-1 min-w-0 p-4 md:p-6">
        {/* Mobile header with toggle */}
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-3">
            <button
              onClick={() => setSidebarOpen(true)}
              className="md:hidden p-2 rounded-md bg-primary text-white hover:bg-primary-dark transition focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none"
              aria-label="Abrir menu"
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            <h1 className="text-2xl md:text-3xl font-bold text-primary">Painel Admin</h1>
          </div>
          <button
            onClick={logout}
            className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none"
          >
            Sair
          </button>
        </div>
        {renderContent()}
      </div>
    </div>
  );
}

export default AdminDashboard;